export const INDEX = '/';
export const LOGS = '/logs';
export const ALL_NEWS = '/allNews';
export const HOME = '/home';
